/**
 * Ce que la page savait d'elle-même en arrivant (25/10/2026).
 *
 * Deux valeurs, figées quand le paquet est ÉVALUÉ, et c'est tout leur prix :
 *
 *   · `CONTROLEE_AU_CHARGEMENT` — un service worker contrôlait-il déjà cette
 *     page dès sa navigation ? Si oui, c'est lui qui a servi la coquille et
 *     les morceaux du paquet, et il les a rangés au passage. Plus tard, un
 *     worker installé pendant la première visite revendique la page
 *     (`clients.claim()`) : `navigator.serviceWorker.controller` devient vrai
 *     alors que la coquille, elle, n'a jamais transité par lui. Lire la valeur
 *     au moment où la balade démarre ferait donc promettre une réouverture
 *     hors ligne qui n'existe pas.
 *   · `ADRESSE_AU_CHARGEMENT` — l'adresse de cette navigation, sans son
 *     fragment : celle sous laquelle le worker a gardé la coquille. Un effet
 *     React la réécrit ensuite (la balade consomme `?mode=`) ; relue tard,
 *     elle chercherait la coquille sous une adresse où rien n'a été rangé.
 *
 * `index.js` importe ce module EN PREMIER, avant React : c'est ce qui garantit
 * que l'instantané précède tout effet. Un morceau chargé à la demande ne doit
 * jamais en être le premier importateur — l'instantané arriverait trop tard.
 *
 * Et rien ici ne jette : ce module s'évalue avant l'application entière, et un
 * `navigator.serviceWorker` refusé (cadre isolé, réglage du navigateur) ne doit
 * pas l'emporter avec lui. Dans le doute, la page se dit « non contrôlée » —
 * c'est le côté où l'on promet moins.
 */
function controlee() {
    try {
        const sw = globalThis.navigator?.serviceWorker;
        return Boolean(sw && sw.controller);
    } catch {
        return false;
    }
}

function adresse() {
    try {
        const href = globalThis.location?.href;
        return href ? String(href).split('#')[0] : '';
    } catch {
        return '';
    }
}

export const CONTROLEE_AU_CHARGEMENT = controlee();
export const ADRESSE_AU_CHARGEMENT = adresse();
